import React from 'react';
import PropTypes from 'prop-types';
import { Utils } from 'versafleet-core';
import { Outlet } from 'react-router-dom';
import withRouterHooks from 'utils/routerHelper';

class App extends React.Component {
  componentDidMount() {
    Utils.Router.setRouter(
      this._transitionTo.bind(this),
      this._replace.bind(this),
      this._getRoutes.bind(this),
      this._getParams.bind(this),
      this._getPath.bind(this),
      this._getQuery.bind(this),
    );
  }

  _transitionTo(route) {
    this.props.navigate(route);
  }

  _replace(route) {
    this.props.navigate(route, { replace: true });
  }

  // Function no longer used/needed, leaving it be
  // until it is also removed from Utils.Router in versafleet-core
  _getRoutes() {
    const routes = this.props.location.pathname.split('/')
      .filter(segment => segment)
      .map(segment => ({ path: segment }));

    return routes;
  }

  _getParams() {
    return this.props.params;
  }

  _getPath() {
    return this.props.location.pathname;
  }

  _getQuery() {
    const [query] = this.props.searchParams;
    const allQuery = Object.fromEntries([...query]);
    return allQuery;
  }

  render() {
    return (
      <div className="versafleet">
        <Utils.Dialog.DialogComponent />
        <Utils.SuccessMessage.SuccessMessageComponent
          location={Utils.SuccessMessage.SuccessMessageComponent.locationConst.OUTER}
        />
        <Outlet />
      </div>
    );
  }
}

App.displayName = 'App';

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.shape({}),
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired,
  searchParams: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.func,
    ]),
  ).isRequired,
};

export default withRouterHooks(App);
